import { styled } from "theme/default/styled";
import { setBackgroundColor_ffffff } from "theme/setter/setBackgroundColorsValues/setBackgroundColor_ffffff";
import { setBorderRadius_15px } from "theme/setter/setBorderRadiusValues/setBorderRadius_15px";
import { setFlexDFFDC } from "theme/setter/setFlexValues/setFlexDFFDC";

export const SPaymentActionModal = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  width: 400px;
  height: 300px;
  padding: 24px 12px;
  transform: translate(-50%, -50%);

  ${setFlexDFFDC};
  ${setBorderRadius_15px};
  ${setBackgroundColor_ffffff};
`;
